import {
  MAIN_CARDS_REQUEST,
  MAIN_CARDS_SUCCESS,
  MAIN_CARDS_FAILURE,
  PROFILE_CARDS_REQUEST,
  PROFILE_CARDS_SUCCESS,
  PROFILE_CARDS_FAILURE,
  MAIN_CARDS_UPDATE,
  MAIN_CARDS_DELETE,
  MAIN_CARDS_LISTENER,
  PROFILE_CARDS_UPDATE,
  PROFILE_CARDS_DELETE,
  PROFILE_CARDS_LISTENER,
  CANCEL_MAIN_CARDS_LISTENER,
  CANCEL_PROFILE_CARDS_LISTENER,
  MAIN_CARDS_ADD,
  PROFILE_CARDS_ADD,
  HAS_MORE,
  NAV_PROFILE_CARDS
} from "../actions/cardsActions";


const initialState = {
  maincardsListeners: [],
  profileCardsListeners: [],
  profileCards: {},
  maincards: {},
  lastCard: "",
  cardRemoved: "",
  isCardFetching: false,
  hasMore: true,
  cardsError: "",
  locArr: [],
  navcards: {}
};

const cardsReducer = (state = initialState, action) => {
  const isDocExist = (id, list) => Object.keys(list).some(item => item === id);

  const fillLocToMap = cards => {
    let tempArr = [];
    Object.keys(cards).map(key => {
      tempArr.push(cards[key].location);
    });
    if (tempArr.length) return tempArr;
  };
  const removeCard = (cards, id) => {
    delete cards[id];
    fillLocToMap(cards);
    return cards;
  };

  const removeListeners = listeners => {
    let i = 0;
    listeners.forEach(listener => {
      i = i + 1;
      listener();
      if (i === listeners.length) {
        listeners.length = 0;
        return listeners;
      }
    });
  };

  switch (action.type) {
    case MAIN_CARDS_REQUEST:
      return {
        ...state,
        isCardFetching: true,
        cardsError: ""
      };
    case MAIN_CARDS_SUCCESS:
      return {
        ...state,
        maincards: { ...state.maincards, ...action.maincards },
        lastCard: action.lastCard,
        isCardFetching: false,
        locArr: [...fillLocToMap({ ...state.maincards, ...action.maincards })]
      };
    case MAIN_CARDS_FAILURE:
      return {
        ...state,
        isCardFetching: false,
        cardsError: action.error
      };
    case MAIN_CARDS_ADD:
      if (isDocExist(action.id, state.maincards)) {
        return { ...state };
      } else {

        return {
          ...state,
          maincards: {
            ...state.maincards,
            [action.id]: action.data
          },
          locArr: [
            ...fillLocToMap({
              ...state.maincards,
              [action.id]: action.data
            })
          ]
        };
      }

    case MAIN_CARDS_UPDATE:
      return {
        ...state,
        maincards: { ...state.maincards, [action.id]: action.data }
      };

    case MAIN_CARDS_DELETE:
      return {
        ...state,
        maincards: { ...removeCard(state.maincards, action.id) },
        cardRemoved: action.id
      };

    case MAIN_CARDS_LISTENER:
      return {
        ...state,
        maincardsListeners: [...state.maincardsListeners, action.listener]
      };

    case PROFILE_CARDS_REQUEST:
      return {
        ...state,
        isCardFetching: true,
        cardsError: ""
      };
    case PROFILE_CARDS_SUCCESS:
      return {
        ...state,
        profileCards: { ...state.profileCards, ...action.profileCards },
        lastCard: action.lastCard,
        isCardFetching: false
      };
    case PROFILE_CARDS_FAILURE:
      return {
        ...state,
        isCardFetching: false,
        cardsError: action.error
      };
    case "LOC_TO_MAP":
      return {
        ...state,
        locArr: action.value
      };
    case NAV_PROFILE_CARDS:
      return {
        ...state,
        navcards: action.value
      };
    case PROFILE_CARDS_ADD:
      if (isDocExist(action.id, state.profileCards)) {
        return { ...state };
      } else {
        return {
          ...state,
          profileCards: {
            ...state.profileCards,
            [action.id]: action.data
          }
        };
      }
    case PROFILE_CARDS_UPDATE:
      return {
        ...state,
        profileCards: { ...state.profileCards, [action.id]: action.data }
      };
    case PROFILE_CARDS_DELETE:
      return {
        ...state,
        profileCards: { ...removeCard(state.profileCards, action.id) },
        cardRemoved: action.id
      };
    case PROFILE_CARDS_LISTENER:
      return {
        ...state,
        profileCardsListeners: [...state.profileCardsListeners, action.listener]
      };
    case CANCEL_MAIN_CARDS_LISTENER:
      removeListeners(state.maincardsListeners);
      return {
        ...state,
        maincardsListeners: [],
        maincards: {},
        hasMore: true,
        locArr: []
      };
    case CANCEL_PROFILE_CARDS_LISTENER:
      removeListeners(state.profileCardsListeners);
      return {
        ...state,
        profileCardsListeners: [],
        profileCards: {},
        hasMore: true
      };

    case HAS_MORE:
      return {
        ...state,
        hasMore: action.value
      };

    default:
      return state;
  }
};
export default cardsReducer;
